import { WeaTools } from 'ecCom'

export const getSearchList = (params) => {
    return WeaTools.callApi('/api/hrm/search/getHrmSearchResult', 'POST', params);
}

export const getHrmSearchCondition = (params) => {
    return WeaTools.callApi('/api/hrm/search/getHrmSearchCondition', 'GET', params);
}

export const getRightMenu = (params) => {
    return WeaTools.callApi('/api/hrm/search/getRightMenu', 'GET', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/query.js